import React, { useEffect } from "react";
// import ServicesButtonList from "../components/ServicesButtonList";
import AOS from "aos";
import "aos/dist/aos.css";
import Schema from "./Schema";
import ServiceNavigator from "./ServiceNavigator";
const PvInstallation = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="font-sans text-gray-900 bg-gray-100">
    <Schema />
    
      {/* Hero Section */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-3xl">
          <h2 className="text-5xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Solar PV Installation
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 mb-4">
            Driven by Science. Built for Sustainability.
          </p>
          <p className="italic text-gray-400">
            Trusted Worldwide. Installed by Experts.
          </p>
        </div>
      </section>

      
      {/* Info Section */}
      <section
        className="px-6 py-14 max-w-5xl mx-auto text-lg leading-relaxed space-y-14"
        data-aos="fade-up"
      >
        {/* Text Block */}
        <div>
          <p className="text-gray-700 mb-4 text-justify">
            We don’t just install solar – we engineer energy that lasts.
          </p>
          <p className="text-gray-700 mb-6 text-justify">
            At <strong>Solar Care International (Pvt) Ltd</strong>, we specialize in high-performance solar solutions for homes and businesses — backed by over <strong>6,800+ kW</strong> of installations and built on our proven <strong>TYPE SCI Method</strong>.
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-black">
            Our Installation Standards
          </h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 text-base text-black">
            {[
              "TYPE SCI Method – Precision-engineered installation",
              "Aerodynamic Cooling – Boosts panel efficiency",
              "Top-Grade Components – Certified & durable",
              "Global Standards – Safety. Performance. Reliability.",
              "Expert Validation – Approved by 32 industry specialists",
              "Tailored Design – For your rooftop or commercial space",
              "Total Support – From consultation to maintenance",
            ].map((item, idx) => (
              <li key={idx} className="bg-white rounded-full px-6 py-4 text-center">
                {item}
              </li>
            ))}
          </ul>

          <p className="mt-6 italic text-gray-700">
            Clean energy is only sustainable when installed right. <br />
            <strong>We make it right.</strong>
          </p>
        </div>

        {/* Video Block */}
        <div className="mt-16 overflow-hidden rounded-3xl shadow-lg">
          <video
            src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1749478127/WhatsApp_Video_2025-06-09_at_7.34.59_PM_nrxvha.mp4"
            className="w-full h-auto object-cover"
            autoPlay
            muted
            loop
            playsInline
          >
            Your browser does not support the video tag.
          </video>
        </div>
      </section>
      
      {/* Image Gallery */}
      <section className="px-6 pt-10 pb-20 max-w-6xl mx-auto" data-aos="fade-up">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367253/WhatsApp_Image_2025-06-15_at_4.11.56_PM_cx7izd.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367253/WhatsApp_Image_2025-06-15_at_4.11.53_PM_ehezfk.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367254/WhatsApp_Image_2025-06-15_at_4.11.49_PM_kcbnv4.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367254/WhatsApp_Image_2025-06-15_at_4.11.48_PM_jbcsy2.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367314/WhatsApp_Image_2025-06-15_at_4.13.27_PM_lhqnid.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367314/WhatsApp_Image_2025-06-15_at_4.11.59_PM_ldtnxb.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367318/WhatsApp_Image_2025-06-15_at_4.12.46_PM_lkggm9.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367318/WhatsApp_Image_2025-06-15_at_4.13.05_PM_fuiqrl.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367319/WhatsApp_Image_2025-06-15_at_4.13.15_PM_xhnnzl.jpg",
                  "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1751367253/WhatsApp_Image_2025-06-15_at_4.11.49_PM_1_x9g7ir.jpg",
                ].map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`PV Installation ${i + 1}`}
                    className="rounded-3xl shadow-lg transition-transform duration-300 hover:scale-105 w-full object-cover"
                  />
                ))}
              </div>
            </section>

      {/* Call to Action */}
      <section className="py-24 px-6 text-center max-w-4xl mx-auto" data-aos="fade-up">
        <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-yellow-400 via-pink-400 to-yellow-300 bg-clip-text text-transparent mb-10 p-4">
          Book Your PV Installation Today
        </h2>
        <p className="text-gray-700 mb-6 text-lg">
          Join thousands who trust SolarCare for quality, certified, future-ready installations across Sri Lanka and beyond.
        </p>
      </section>

      {/* Contact Section */}
      <section
        className="flex flex-col items-center gap-8 mt-16 mb-16 bg-black text-white rounded-3xl overflow-hidden mx-4 sm:mx-auto py-20 max-w-6xl text-center"
        data-aos="fade-up"
      >
        <div className="w-full max-w-2xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
            Get in Touch
          </h2>
          <div className="w-full max-w-2xl">
          <p className="mb-2 font-medium">Solar Care International Pvt Ltd</p>
          <p className="mb-1">No.44/1A, Chapel Lane, Nugegoda, Sri Lanka</p>
          <p className="mb-1">+94 114 199 225 / +94 777 129 021</p>
          <p>
            <a
              href="mailto:info@solarcareinternational.com"
              className="text-blue-400 hover:text-blue-200 underline transition"
            >
              info@solarcareinternational.com
            </a>
          </p>
        </div>
        </div>
      </section>

      {/* <ServicesButtonList /> */}
      <ServiceNavigator />
    </div>
  );
};

export default PvInstallation;